export default {
  hello: 'آهلا بك',
  createNewAccount: 'إنشاء حساب جديد',
  byClickingOnTheButtonBelow: 'بالنقر على الزر أدناه، فإنك توافق على كل ',
  createAccount: 'إنشاء حساب',
  youHaveAnAccount: 'هل لديك حساب ؟',
  loginNow: 'تسجيل الدخول الآن',
};
